import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../../utils/useTranslation';
import { DashboardPage } from '../dashboard/DashboardPage';
import { Button } from '../input/Button';
import { Flex } from '../layout/Flex';
import { Typography } from '../typography/Typography';

export const CollectionNotFound = () => {
    const t = useTranslation();

    return (
        <DashboardPage>
            <Flex px={4} height="100%" justifyContent="center">
                <Typography variant="title1" weight="heavy" pb={1.5}>
                    {t('Не удалось загрузить коллекцию')}
                </Typography>
                <Typography pb={3}>
                    {t('Возможно, автор ее удалил или случилась ошибка')}
                </Typography>
                <Flex spacing={1}>
                    <Button onClick={() => window.location.reload()} color="secondary">
                        {t('Попробовать ещё раз')}
                    </Button>
                    <Button as={Link} to="/">
                        {t('Найти интересное в ленте')}
                    </Button>
                </Flex>
            </Flex>
        </DashboardPage>
    );
};
